<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chartData: {
        labels: [ 1,2,3,4,5,6,7,8,9,10 ],
        datasets: [ 
          {
            label: 'Dataset 1',
            data: [1,6,7,8,9,10,2,3,4,5],
            backgroundColor: "#FFFFFF",
          },
          {
            label: 'Dataset 2',
            data: [7,8,9,10,1,2,3,4,5,6],
            backgroundColor: "#ADC509",
          },
          {
            label: 'Dataset 3',
            data: [4,5,6,7.1,2,3,8,9,10],
            backgroundColor: "#56672E",
          },
        ]
      },
      chartOptions: {
        scales: {
          x: {
            stacked: true,
            display: false
          },
          y: {
            stacked: true,
            display: false
          }
        },
        responsive: true,
        plugins: {
          legend:{
            display: false
          }
        }
      }
    }
  }
}
</script>